import { isTruthy } from './isTruthy';

/**
 * @description
 * Given an array of elements i.e [1, {test:2}, 'black'], it should iterate through
 * and ensure no values are undefined, null or empty strings.
 * */
export const isTruthyArray = (arr: Array<unknown>) => arr.every(isTruthy);
